const isObject = (item) => item && typeof item === "object" && !Array.isArray(item);
var isObject$1 = isObject;

export { isObject$1 as default };
